<script>
export default {
    name: 'ComponentsFooter',
}
</script>
<template>
    <footer>
        <div class="container">
            <div class="d-flex flex-column flex-lg-row mb-5">
                <div class="d-flex flex-1 flex-column flex-md-row justify-content-md-between justify-content-lg-between">
                    <nav>
                        <h2>MENU</h2>
                        <ul>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/eksperci/" target="_blank">
                                    Eksperci
                                </a>
                            </li>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/porady/" target="_blank">
                                    Porady
                                </a>
                            </li>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/oferta/" target="_blank">
                                    Oferta
                                </a>
                            </li>
                            <li>
                                <a href="http://sklep.wszystkozaczynasiewglowie.pl/" target="_blank">
                                    Sklep
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <nav>
                        <h2>PROFIL</h2>
                        <ul>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/profil/moje-kursy/" target="_blank">
                                    Moje kursy
                                </a>
                            </li>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/profil/dane-profilu/" target="_blank">
                                    Dane profilu
                                </a>
                            </li>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/profil/wiadomosci/" target="_blank">
                                    Wiadomości
                                </a>
                            </li>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/Security/login" target="_blank">
                                    Logowanie
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <nav>
                        <h2>KONTAKT</h2>
                        <ul>
                            <li>
                                <a href="mailto:biuro@adriannasobol.pl" target="_blank">
                                    biuro@adriannasobol.pl
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <nav class="mr-0 mr-lg-5">
                        <h2>FAQ</h2>
                        <ul>
                            <li>
                                <a href="https://wszystkozaczynasiewglowie.pl/pytania-i-odpowiedzi-3/" target="_blank">
                                    Pytania i odpowiedzi
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <ul class="mt-3 mt-xl-0">
                    <li>
                        <a href="https://wszystkozaczynasiewglowie.pl/regulamin/" target="_blank">
                            Regulamin
                        </a>
                    </li>
                    <li>
                        <router-link :to="{name:'privacyPolicy'}">
                            Polityka prywatności
                        </router-link>
                    </li>
                    <li>
                        <a href="https://wszystkozaczynasiewglowie.pl/newsletter" target="_blank">
                            Newsletter
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                Zdrowie zaczyna się w głowie &copy; {{ (new Date()).getFullYear() }}
            </div>
        </div>
    </footer>
</template>
